module.exports = __webpack_public_path__ + "img/banderaMexico.d58507ec.jpg";